module.exports = __webpack_public_path__ + "img/thumb-flespompoen-op-bakplaat.c3b77f4e.jpeg";